/* eslint-disable react/prop-types */
import * as React from 'react';

import { translate } from '~l10n/client';
import _ from 'underscore';

import { roomsKeys } from '~teacher/hook/room/roomsKeys';
import { queryClient } from '~teacher/queryClient';
import Constants from 'Constants';
import DropdownList from 'DropdownList';
import Input from 'Input';
import RemoveIcon from 'RemoveIcon';

let c = null;
let m = null;

export default class StudentEntryView extends React.Component {
  constructor(props) {
    super(props);

    let student = this.props.studentData;

    this.state = {
      bodyClicked: this.bodyClicked.bind(this), // Make it possible to remove the bodyClicked listener.
      editMode: student.inEdit || false,
      errors: student.errors || {},
      indexPos: student.indexPos || 'noIndex',
      moreButtonClicked: false,
      studentDBID: student.id || '',
      studentID: student.student_id || '',
      studentFirstName: student.first_name || '',
      studentLastName: student.last_name || '',
      studentEmail: student.email || '',
    };
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    let studentData = newProps.studentData || {};

    this.setState({
      studentID: studentData.student_id || '',
      studentDBID: studentData.id || '',
      studentFirstName: studentData.first_name || '',
      studentLastName: studentData.last_name || '',
      studentEmail: studentData.email || '',
      editMode: studentData.inEdit || false,
      indexPos: studentData.indexPos || 'noIndex',
      errors: studentData.errors || {},
    });
  }

  // Validate on blur and send the value of the field. If the student is new, send
  // the position of the edited student in the new student's list (1, 5, 10 chunks).

  firstNameBlur() {
    if (this.state.studentFirstName !== this.props.studentData.first_name) {
      let student = c.validateStudent(
        'first_name',
        this.state.studentFirstName,
        this.state.indexPos,
        this.state.studentDBID
      );
      this.setState({
        errors: student.errors,
      });
    }
  }

  lastNameBlur() {
    if (this.state.studentLastName !== this.props.studentData.last_name) {
      let student = c.validateStudent(
        'last_name',
        this.state.studentLastName,
        this.state.indexPos,
        this.state.studentDBID
      );
      this.setState({
        errors: student.errors,
      });
    }
  }

  studentIdBlur() {
    if (this.state.studentID !== this.props.studentData.student_id) {
      let student = c.validateStudent(
        'student_id',
        this.state.studentID,
        this.state.indexPos,
        this.state.studentDBID
      );
      this.setState({
        errors: student.errors,
      });
    }
  }

  studentEmailBlur() {
    if (this.state.studentEmail !== this.props.studentData.email) {
      let student = c.validateStudent(
        'email',
        this.state.studentEmail,
        this.state.indexPos,
        this.state.studentDBID
      );
      this.setState({
        errors: student.errors,
      });
    }
  }

  firstNameChanged(event) {
    if (this.props.studentData.errors) {
      this.props.studentData.errors.first_name = null;
    }

    this.setState({
      studentFirstName: event.target.value,
    });
  }

  lastNameChanged(event) {
    if (this.props.studentData.errors) {
      this.props.studentData.errors.last_name = null;
    }

    this.setState({
      studentLastName: event.target.value,
    });
  }

  studentIdChanged(event) {
    if (this.props.studentData.errors) {
      this.props.studentData.errors.student_id = null;
    }

    this.setState({
      studentID: event.target.value.toUpperCase().trim(),
    });
  }

  studentEmailChanged(event) {
    if (this.props.studentData.errors) {
      this.props.studentData.errors.email = null;
    }

    this.setState({
      studentEmail: event.target.value.toLowerCase().trim(),
    });
  }

  bodyClicked() {
    document.body.removeEventListener('click', this.state.bodyClicked);

    _.defer(() => {
      this.setState({
        moreButtonClicked: false,
      });
    });
  }

  render() {
    c = this.props.controller;
    m = this.props.model;

    let studentData = this.props.studentData || {};
    let studentBullet = null;
    let studentActionButtons = null;
    let studentIDColStyle = this.state.editMode
      ? 'student-id'
      : 'student-id student-id-col';

    if (studentData.newStudent && !this.props.singular) {
      // If only one student is in the popup, don't show the index number and remove the student button.
      if (!this.props.disableListIndex) {
        studentBullet = (
          <span className="student-index">{studentData.indexPos}</span>
        );

        studentActionButtons = (
          <span
            className="align-right remove-new-student-container"
            onClick={() =>
              this.props.deleteNewStudent(this.props.studentData.indexPos)
            }
          >
            <RemoveIcon className="align-right remove-new-student" />
          </span>
        );
      }
    } else {
      if (this.state.editMode) {
        studentActionButtons = (
          <div className="align-right edit-students-btns">
            <button
              className="button button-secondary button-large"
              onClick={() => {
                // TODO .... Passing different argument types based on context is garbage:
                if (this.props.singular) {
                  c.updateStudent(this.props.roomId, true);
                } else {
                  c.updateStudent(this.props.roomId, this.state.studentDBID);
                }
                queryClient.invalidateQueries(roomsKeys.list());
              }}
            >
              {translate('Save')}
            </button>
            <button
              onClick={() =>
                c.cancelEditStudentButtonClicked(
                  this.props.studentData.id,
                  this.props.singular
                )
              }
              className="button button-secondary-common button-large"
            >
              {translate('Cancel')}
            </button>
          </div>
        );
      } else {
        studentBullet = (
          <span
            className={
              studentData && studentData.logged_in
                ? 'presence present'
                : 'presence absent'
            }
          >
            {studentData && studentData.logged_in ? (
              <i className="student-presence" data-icon="J" />
            ) : (
              <svg
                fill="#cccccc"
                dangerouslySetInnerHTML={{
                  __html:
                    '<path class="st0" d="M12,0C5.4,0,0,5.4,0,12c0,6.6,5.4,12,12,12c6.6,0,12-5.4,12-12C24,5.4,18.6,0,12,0z M21.9,12 c0,2.3-0.8,4.5-2.2,6.2L6.2,3.9C7.9,2.8,9.9,2.1,12,2.1C17.5,2.1,21.9,6.5,21.9,12z M2.1,12c0-2.6,1-4.9,2.6-6.7l13.6,14.3 c-1.7,1.4-3.9,2.3-6.3,2.3C6.5,21.9,2.1,17.5,2.1,12z"/>',
                }}
              />
            )}
          </span>
        );

        studentActionButtons = (
          <div className="right-action-buttons">
            <span
              className="delete-student-container"
              onClick={() => {
                c.deleteStudent(this.props.studentData, this.props.roomId);
                queryClient.invalidateQueries(roomsKeys.all);
              }}
            >
              <i className="student-action" data-icon="L" />
            </span>
            <span
              className="edit-student-container"
              onClick={(event) =>
                c.editStudentButtonClicked(event, this.state.studentID)
              }
            >
              <i className="student-action" data-icon="C" />
            </span>
          </div>
        );
      }
    }

    let errors = this.state.errors;

    // The error might simply be a boolean value.
    let lastNameError = errors && errors.last_name;
    let firstNameError = errors && errors.first_name;
    let studentIdError = errors && errors.student_id;
    let studentEmailError = errors && errors.email;

    // If there's an error, see if there's a message too.
    if (lastNameError && errors.last_name.errorMsg) {
      lastNameError = errors.last_name.errorMsg;
    }

    if (firstNameError && errors.first_name.errorMsg) {
      firstNameError = errors.first_name.errorMsg;
    }

    if (studentIdError && errors.student_id.errorMsg) {
      studentIdError = errors.student_id.errorMsg;
    }

    return (
      <div className="add-student clearfix">
        <div
          className={
            'add-student-form clearfix' +
            (!this.state.editMode ? ' list-view' : ' edit-view')
          }
        >
          {studentBullet}
          <div className="student-data-wrapper">
            <Input
              placeholder={translate('Last Name')}
              className="last-name"
              containerClass="input-name"
              value={
                this.state.editMode
                  ? this.state.studentLastName
                  : this.state.studentLastName +
                    ', ' +
                    this.state.studentFirstName
              }
              onChange={(event) => this.lastNameChanged(event)}
              onBlur={() => this.lastNameBlur()}
              error={lastNameError}
              disabled={!this.state.editMode}
              hideTooltip={
                this.props.studentData && this.props.studentData.hideTooltip
              }
              tooltipLocation="below"
            />
            {this.state.editMode ? (
              <Input
                placeholder={translate('First Name')}
                containerClass="input-name"
                value={this.state.studentFirstName}
                onChange={(event) => this.firstNameChanged(event)}
                onBlur={() => this.firstNameBlur()}
                error={firstNameError}
                disabled={!this.state.editMode}
                hideTooltip={
                  this.props.studentData && this.props.studentData.hideTooltip
                }
                tooltipLocation="below"
              />
            ) : null}
            <Input
              placeholder={translate('Student ID')}
              containerClass="input-student-id"
              className={studentIDColStyle}
              value={this.state.studentID}
              maxLength={Constants.MAX_STUDENT_ID_LENGTH}
              onChange={(event) => this.studentIdChanged(event)}
              onBlur={() => this.studentIdBlur()}
              error={studentIdError}
              disabled={!this.state.editMode}
              hideTooltip={
                this.props.studentData && this.props.studentData.hideTooltip
              }
              title={this.state.studentID}
              tooltipLocation="below"
            />
            <Input
              placeholder={
                this.state.editMode
                  ? translate('Email (optional)')
                  : translate('none')
              }
              containerClass="input-email"
              value={this.state.studentEmail}
              maxLength={Constants.MAX_STUDENT_EMAIL_LENGTH}
              onChange={(event) => this.studentEmailChanged(event)}
              onBlur={() => this.studentEmailBlur()}
              error={studentEmailError}
              disabled={!this.state.editMode}
              hideTooltip={
                this.props.studentData && this.props.studentData.hideTooltip
              }
              tooltipLocation="below"
            />
          </div>
          {studentActionButtons}
        </div>
      </div>
    );
  }
}
